import { NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { randomId } from 'tsui/lib/cross-cutting/util';

@Component({
  selector: 'jupiter-panel-container',
  standalone: true,
  imports: [NgClass],
  templateUrl: './panel-container.component.html',
  styleUrl: './panel-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelContainerComponent implements AfterViewInit {
  @Input() ui = { noPadding: false };

  // experimental
  id = '';

  constructor() {
    // experimental
    this.id = `x${randomId()}`;
  }

  ngAfterViewInit(): void {
    // experimental
    // new PerfectScrollbar(`.${this.id}`, {
    //   wheelSpeed: 1,
    //   minScrollbarLength: 20,
    //   swipeEasing: true,
    // });
  }
}
